@if (!loadingReferrals) {
  @if (showIneligibleReferrals) {
    <nav class="nav nav-pills mb-2">
      <a class="nav-item nav-link active"
        [class.active]="currentTab === 'eligibleReferrals'"
        (click)="tabClick($event, 'eligibleReferrals')"
        href="#">
        Eligible Referrals ({{ eligibleReferrals.length }})
      </a>
      <a class="nav-item nav-link"
        [class.active]="currentTab === 'ineligibleReferrals'"
        (click)="tabClick($event, 'ineligibleReferrals')"
        href="#">
        Ineligible Referrals ({{ ineligibleReferrals.length }})
      </a>
    </nav>
  }
  @if (!showIneligibleReferrals || currentTab === 'eligibleReferrals') {
    <ng-container
      [ngTemplateOutlet]="referralList"
      [ngTemplateOutletContext]="{ iterable: eligibleReferralsOrOptions }" />
  }
  @if (currentTab === 'ineligibleReferrals') {
    <ng-container
      [ngTemplateOutlet]="referralList"
      [ngTemplateOutletContext]="{ iterable: ineligibleReferrals }" />
  }
} @else {
  <div class="mt-1 mb-2 ms-1"><mat-spinner diameter="30" /></div>
}

<ng-template #referralList let-iterable="iterable">
  <div [class.compact]="compactClientView">
    @if (iterable.length > 0) {
      <table class="table table-sm"
        >
        <thead [ngClass]="{ 'table-dark': dark }">
          <tr>
            <th>Referral Date</th>
            <th>
              @if (compactClientView) {
                Referred To Provider
              }
              @if (!compactClientView) {
                Receiving Provider / Practice
              }
            </th>
            <th>Specialty</th>
            <th>Receiving Office</th>
            <th>Referring Provider</th>
            <th>Location</th>
            <th>Ref-ID</th>
            @if (!compactClientView) {
              <th>Status</th>
            }
            @if (!compactClientView) {
              <th>Notes</th>
            }
            @if (!compactClientView) {
              <th>Consult</th>
            }
            @if (!compactClientView) {
              <th>Consult Desc</th>
            }
            @if (!compactClientView) {
              <th>PT Consult Desc</th>
            }
            @if (!compactClientView) {
              <th>Patient MRN</th>
            }
            @if (!compactClientView) {
              <th>EHR Instance</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (item of iterable; track item; let i = $index) {
            <tr [class.selected]="option(item)?.selected"
              [class.row-bottom]="compactClientView || !referral(item).referralReason"
              class="referral">
              <td>{{ referral(item).referralDate | date: 'MM/dd/yyyy' }}</td>
              <td>
                @if (option(item)) {
                  <div
                    class="form-check"
                    [ngClass]="{ disabled: option(item).disabled }">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'rmvProvider' + i"
                        [disabled]="option(item).disabled"
                        [(ngModel)]="option(item).verification.provider"
                        (change)="onReferralMatchOptionChange(option(item))"
                        />
                      {{ referral(item).receivingProviderDisplayNameWithNpi }}
                      @if (!compactClientView) {
                        <div>
                          {{ referral(item).receivingProviderDisplaySpecialty }}
                        </div>
                      }
                    </label>
                  </div>
                }
                @if (!option(item)) {
                  <div>
                    {{ referral(item).receivingProviderDisplayNameWithNpi }}
                    @if (!compactClientView) {
                      <div>
                        {{ referral(item).receivingProviderDisplaySpecialty }}
                      </div>
                    }
                  </div>
                }
              </td>
              <td>
                @if (option(item)) {
                  <div
                    class="form-check"
                    [ngClass]="{ disabled: option(item).disabled }">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'rmvSpecialty' + i"
                        [disabled]="option(item).disabled"
                        [(ngModel)]="option(item).verification.specialty"
                        (change)="onReferralMatchOptionChange(option(item))"
                        />
                      {{ referral(item).referralSpecialty }}
                    </label>
                  </div>
                }
                @if (!option(item)) {
                  <div>
                    {{ referral(item).referralSpecialty }}
                  </div>
                }
              </td>
              <td>
                @if (option(item)) {
                  <div
                    class="form-check"
                    [ngClass]="{ disabled: option(item).disabled }">
                    <label class="form-check-label">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'rmvOffice' + i"
                        [disabled]="option(item).disabled"
                        [(ngModel)]="option(item).verification.office"
                        (change)="onReferralMatchOptionChange(option(item))"
                        />
                      <div>{{ referral(item).receivingOfficeName }}</div>
                      @if (!compactClientView) {
                        <small>
                          <strong>FAX:</strong> <app-phone-number [number]="referral(item).receivingProviderFax" />
                        </small>
                      }
                    </label>
                  </div>
                }
                @if (!option(item)) {
                  <div>
                    <div>{{ referral(item).receivingOfficeName }}</div>
                    @if (!compactClientView) {
                      <small>
                        <strong>FAX:</strong> <app-phone-number [number]="referral(item).receivingProviderFax" />
                      </small>
                    }
                  </div>
                }
              </td>
              <td>{{ referral(item).sendingProviderDisplayNameWithNpi }}</td>
              <td>{{ referral(item).sendingLocation }}</td>
              <td>{{ referral(item).ehrIdentifier }}</td>
              @if (!compactClientView) {
                <td>{{ referral(item).referralEhrStatus }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).referralEhrNotes }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).referralConsultInEhr }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).referralConsultEhrDescriptions }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).patientConsultEhrDescriptions }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).sourcePatientMrn }}</td>
              }
              @if (!compactClientView) {
                <td>{{ referral(item).ehrInstance }}</td>
              }
            </tr>
            @if (!compactClientView && referral(item).referralReason) {
              <tr
                class="referral-reason row-bottom"
                [class.selected]="option(item)?.selected">
                <td colspan="14"><strong>REFERRAL REASON:</strong> {{ referral(item).referralReason }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    } @else {
      <div class="my-2">No patient referrals found.</div>
    }
  </div>
</ng-template>


